import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::update
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:1066
* @route '/teacher/settings/qualifications'
*/
export const update = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/teacher/settings/qualifications',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::update
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:1066
* @route '/teacher/settings/qualifications'
*/
update.url = (options?: RouteQueryOptions) => {
    return update.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::update
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:1066
* @route '/teacher/settings/qualifications'
*/
update.put = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(options),
    method: 'put',
})

const qualifications = {
    update: Object.assign(update, update),
}

export default qualifications